module.exports = __webpack_public_path__ + "img/drug_bottom.b5dde8b5.png";